import { useEffect, useState } from "react";

const useChangeTooltipMsg = (initialMsg: string, finalMsg: string) => {
  const [copyMsg, setCopyMsg] = useState(initialMsg);

  useEffect(() => {
    if (copyMsg === finalMsg) {
      setTimeout(() => setCopyMsg(initialMsg), 1800);
    }
  }, [copyMsg, initialMsg, finalMsg]);

  return { copyMsg, setCopyMsg };
};

export default useChangeTooltipMsg;